import { createSlice } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { saveRequest, saveStudent } from '../Request/requestSlice';
import { updateFilesRequest } from '../SearchRequest/requestSearchSlice';

interface SnackbarStore {
  open: boolean
  severity: 'success' | 'error' | 'warning' | 'info',
  message: string
  duration?: number
}

const initialState: SnackbarStore = {
  open: false,
  severity: 'success',
  message: 'Default message',
  duration: 3000
};

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    popSnackbar: (state, action) => {
      state.severity = initialState.severity;
      state.message = action.payload.message;
      state.severity = action.payload.type;
      state.duration = action.payload.duration;
      state.open = true;
    },
    popErrorFileSizeSnackbar: (state) => {
      state.message = t('invalidFileSize');
      state.severity = 'error';
      state.open = true;
    },
    popErrorFileTypeSnackbar: (state) => {
      state.message = t('invalidFileType');
      state.severity = 'error';
      state.open = true;
    },
    closeSnackbar: (state) => {
      state.open = false;
      state.duration = initialState.duration;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(saveStudent.rejected, (state, payload) => {
      state.message = t('errorConsultingData');
      state.severity = 'error';
      state.open = true;
    });

    builder.addCase(updateFilesRequest.fulfilled, (state, action) => {
      state.severity = initialState.severity;
      if (action.payload != null) {
        state.message = t('successMessageOnFilesRequestSended');
      }
      state.open = true;
    });

    builder.addCase(updateFilesRequest.rejected, (state, action: any) => {
      state.severity = 'error';
      if (action.payload?.status) {
        const path: string = action.payload.path;
        const errorComeFromRequest = path.includes('/equivalency/request') && !path.split('/').some(element => element === 'file');
        state.message = t(errorComeFromRequest ? 'requestProblemMessage' : 'fileProblemMessage');
      } else {
        state.message = t('defaultProblemMessage');
      }
      state.open = true;
    });

    builder.addCase(saveRequest.fulfilled, (state, action) => {
      state.severity = initialState.severity;
      if (action.payload != null) {
        state.message = t('successMessageOnRequestSended');
      }
      state.open = true;
    });

    builder.addCase(saveRequest.rejected, (state, action: any) => {
      state.severity = 'error';
      if (action.payload?.status) {
        const path: string = action.payload.path;
        const errorComeFromRequest = path.includes('/equivalency/request') && !path.split('/').some(element => element === 'file');
        state.message = t(errorComeFromRequest ? 'requestProblemMessage' : 'fileProblemMessage');
      } else {
        state.message = t('defaultProblemMessage');
      }
      state.open = true;
    });
  }
});

export const { popSnackbar, popErrorFileSizeSnackbar, popErrorFileTypeSnackbar, closeSnackbar } = snackbarSlice.actions;

export default snackbarSlice.reducer;
